import { operators as e } from "@pendo/aggregations";
const o = {
  name: "Suggested Page Tags Load Events",
  response: () => ({
    location: "request",
    mimeType: "application/json"
  }),
  build: ({ appId: l, blacklist: s, sampleDenominator: a, timeSeries: r, includeAnonymous: p }) => {
    const t = e.pipeline(
      e.unwind("parseUrl.path", { index: "itemIndex" }),
      e.group(
        ["appId", "itemIndex", "parseUrl.path"],
        e.groupField("document_title", e.first("parseUrl.fields._pendo_document_title[0]")),
        e.groupField("numLoads", e.sum("loadsPerUrl")),
        e.groupField("samples", e.list("url"))
      ),
      e.evaluate({
        samples: "if(len(samples) > 5, samples[0:5], samples)"
      }),
      e.evaluate({
        numLoads: `numLoads * ${a}`
      }),
      e.filter("dynamicProbability(parseUrl.path) == 0"),
      e.evaluate({
        suggestedRuleType: '"paths"'
      })
    ), i = e.pipeline(
      e.filter("len(parseUrl.hashBang) == 0 && len(parseUrl.fragment) > 0"),
      e.group(
        ["appId", "parseUrl.fragment"],
        e.groupField("numLoads", e.sum("loadsPerUrl")),
        e.groupField("samples", e.list("url"))
      ),
      e.evaluate({
        samples: "if(len(samples) > 5, samples[0:5], samples)"
      }),
      e.filter("dynamicProbability(parseUrl.fragment) == 0"),
      e.evaluate({
        suggestedRuleType: '"fragment"'
      })
    ), n = e.pipeline(
      e.filter("len(parseUrl.hashBang) > 0 && !isNil(parseUrl.pathFragments)"),
      e.unwind("parseUrl.pathFragments", { index: "itemIndex" }),
      e.group(
        ["appId", "itemIndex", "parseUrl.pathFragments"],
        e.groupField("numLoads", e.sum("loadsPerUrl")),
        e.groupField("samples", e.list("url"))
      ),
      e.evaluate({
        samples: "if(len(samples) > 5, samples[0:5], samples)"
      }),
      e.filter("dynamicProbability(parseUrl.pathFragments) == 0"),
      e.evaluate({
        suggestedRuleType: '"pathFragments"'
      })
    ), d = e.pipeline(
      e.filter("len(parseUrl.hashBang) > 0 && !isEmpty(parseUrl.fieldFragments)"),
      e.evaluate({
        fieldFragmentKeys: "keys(parseUrl.fieldFragments)"
      }),
      e.unwind("fieldFragmentKeys"),
      e.evaluate({
        fieldFragmentVals: "lookup(parseUrl.fieldFragments, fieldFragmentKeys)"
      }),
      e.unwind("fieldFragmentVals"),
      e.group(
        ["appId", "fieldFragmentKeys", "fieldFragmentVals"],
        e.groupField("numLoads", e.sum("loadsPerUrl")),
        e.groupField("samples", e.list("url"))
      ),
      e.evaluate({
        samples: "if(len(samples) > 5, samples[0:5], samples)"
      }),
      e.filter("dynamicProbability(fieldFragmentKeys) == 0"),
      e.evaluate({
        suggestedRuleType: '"queryFragments"'
      })
    ), u = e.pipeline(
      e.filter("!isEmpty(parseUrl.fields)"),
      e.evaluate({
        fieldKeys: "keys(parseUrl.fields)"
      }),
      e.unwind("fieldKeys"),
      e.evaluate({
        fieldVals: "lookup(parseUrl.fields, fieldKeys)"
      }),
      e.unwind("fieldVals"),
      e.group(
        ["appId", "fieldKeys", "fieldVals"],
        e.groupField("numLoads", e.sum("loadsPerUrl")),
        e.groupField("samples", e.list("url"))
      ),
      e.evaluate({
        samples: "if(len(samples) > 5, samples[0:5], samples)"
      }),
      e.filter("fieldKeys != `pendo-designer` && dynamicProbability(fieldKeys) == 0"),
      e.evaluate({
        suggestedRuleType: '"queryParameters"'
      })
    );
    return e.pipeline(
      e.sources.singleEvents({ appId: l, blacklist: s, sampleDenominator: a, timeSeries: r }),
      e.identified(p),
      e.filter("type == `load`"),
      e.select({ url: "url", appId: "appId" }),
      e.group(["url", "appId"], e.groupField("loadsPerUrl", e.count(null))),
      {
        pagesAny: {
          pageMatches: "url"
        }
      },
      e.filter("pageMatches == false"),
      e.sort("-loadsPerUrl"),
      e.evaluate({
        parseUrl: "parseUrl(url)"
      }),
      e.fork(
        t,
        i,
        n,
        d,
        u
      ),
      e.merge(
        ["appId"],
        e.mappings({
          totalLoads: "totalLoads"
        }),
        e.pipeline(
          e.sources.singleEvents({ appId: l, blacklist: s, sampleDenominator: a, timeSeries: r }),
          e.identified(p),
          e.filter("type == `load`"),
          e.select({ url: "url", appId: "appId" }),
          e.group(["appId"], e.groupField("totalLoads", e.count(null))),
          e.evaluate({
            totalLoads: `totalLoads * ${a}`
          })
        )
      ),
      e.evaluate({
        ratioOfAppLoad: "numLoads / totalLoads"
      }),
      e.sort(["-ratioOfAppLoad", "-numLoads"]),
      e.limit(300)
    );
  }
}, g = {
  SuggestedPagesLoadEventsAggregation: o
}, f = {
  ...g
};
export {
  o as SuggestedPagesLoadEventsAggregation,
  f as default
};
